($ => {
  "use strict";
  
  class ProductForm {
    constructor({ form }) {
      this.form = form;
      this.variant_id= form.getAttribute('data-variant-id');
      this.missing_details = false;

      // Product Equations/Validation
      this.product_eqn = form.getAttribute('data-product-eqn');
      this.product_validation = JSON.parse(form.getAttribute('data-product-validation')); 
      this.product_base_price = +form.getAttribute('data-product-base-price');
      this.product_area_breaks = JSON.parse(form.getAttribute('data-product-area-breaks')); 
      this.product_width_eqn = form.getAttribute('data-product-width-eqn');
      this.product_length_eqn = form.getAttribute('data-product-length-eqn');
      this.material_width_max = form.getAttribute('data-material-width-max');
      this.material_length_max = form.getAttribute('data-material-length-max');
      this.material_width_pure_max = form.getAttribute('data-material-width-pure-max');
      this.material_length_pure_max = form.getAttribute('data-material-length-pure-max');
      this.comparison_validation_eqns = JSON.parse(form.getAttribute('data-comparison-validations')) || [];
      this.product_tags = form.getAttribute('data-product-tags');

      // Failed comparison validations
      this.failed_comparison_validations = [];
      this.form_error_message_container = $("#form-error-message-container");

      //Product Components
      this.product_components = JSON.parse(form.getAttribute('data-product-components')) || [];

      // Equations to Calculate Companion Box Size for Divider
      this.companion_box_length_eqn_E = form.getAttribute('data-product-companionbox-length-eqn-e');
      this.companion_box_height_eqn_E = form.getAttribute('data-product-companionbox-height-eqn-e');
      this.companion_box_length_eqn_B = form.getAttribute('data-product-companionbox-length-eqn-b');
      this.companion_box_height_eqn_B = form.getAttribute('data-product-companionbox-height-eqn-b');
      this.companion_box_width_eqn_E = form.getAttribute('data-product-companionbox-width-eqn-e');
      this.companion_box_width_eqn_B = form.getAttribute('data-product-companionbox-width-eqn-b');

      // Product measurements
      this.length = form.querySelector('[name=l]');
      this.width = form.querySelector('[name=w]');
      this.depth = form.querySelector('[name=h]');

      // Number of Products (for Divider)
      this.number_of_products = form.querySelector('[name=number_of_products]') ?? null;

      this.custom_cta = form.querySelectorAll('.js-custom-input-cta');
      this.custom_sizes_container = form.querySelector('.js-custom-sizes-container');
      this.standard_qty = form.querySelector('.js-standard-box-qty');
      this.standard_qty_options = document.querySelectorAll('.js-qty-option-label .js-qty-span');
      this.item_qty = form.querySelector('[name=quantity]');
      this.quantityTouched = false;

      // Track whether custom quantity input has been changed at least once
      if (this.item_qty) {
          this.item_qty.addEventListener('input', () => {
          this.quantityTouched = true;
        }, { once: true });
      }

      // Product Materials
      this.pureprint = form.querySelector('#material_pure-print');
      this.pureprint_kraft = form.querySelector('#material_pure-print-kraft');
      this.pureprint_matte = form.querySelector('#material_pure-print-matte');
      this.pureprint_matte_kraft = form.querySelector('#material_pure-print-matte-kraft');
      this.glossfinish = form.querySelector('#gloss-finish');
      this.kraft_pureprint = form.querySelector('#material_kraft-pure-print');

      // Product Print Options
      this.design_online_enabled = form.getAttribute('data-design-online');
      this.no_print_finish = form.querySelector('#no-print');

      this.varnish = form.querySelector('#gloss-finish');
      this.default_print = form.querySelector('#custom-art');
      this.inside_print = form.querySelector('#inside-print');
      this.doublesided_print = form.querySelector('#double-side');

      this.component_no_print_inputs = form.querySelectorAll(".no-print.component-print-option"); 
      this.component_default_print_option_inputs = form.querySelectorAll(".custom-art.component-print-option"); 

      //Rush/Sample options
      this.rush_production = form.querySelector('#rush-production');
      this.rush_option_msg = form.querySelector('.rush-option--full-order');
      this.sample_option_msg = form.querySelector('.rush-option--sample-order');

      //Product flutes
      this.product_flute_override = form.getAttribute('data-product-flute-override');
      this.available_flutes = JSON.parse(form.getAttribute('data-available-flutes'));

      //Glue
      this.glue = form.getAttribute('data-glue');

      //MFG facilities
      this.mfg_facilities = form.getAttribute('data-mfg-facilities');
      this.mfg_facilities = this.mfg_facilities?.length > 0 ? this.mfg_facilities.split(',') : ['Kent'];
      this.mfg_facilities = this.mfg_facilities.map(f => 
      {
        f = f.trim();
        return f.charAt(0).toUpperCase() + f.substr(1).toLowerCase()
      });

      //Static Prices
      this.standard_qty_list = form.getAttribute('data-standard-qty-list');
      this.standard_qty_list = this.standard_qty_list ? this.standard_qty_list.split(',') : null;
      this.static_price_list = form.getAttribute('data-static-price-list');
      this.static_price_list = this.static_price_list? this.static_price_list.split(',') : null;
      this.multi_size_static_price = JSON.parse(form.getAttribute('data-multi-size-static-price') || null);

      //NAPCO Shipping Values
      this.napco_carton_dimensions = form.getAttribute('data-shipping-carton-dims');
      this.napco_carton_dimensions = this.napco_carton_dimensions ? JSON.parse(this.napco_carton_dimensions) : null;
      this.napco_carton_qty_per_break = form.getAttribute('data-shipping-carton-qty-per-break');
      this.napco_carton_qty_per_break = this.napco_carton_qty_per_break ? JSON.parse(this.napco_carton_qty_per_break) : null;
      this.napco_carton_weight_lbs = form.getAttribute('data-shipping-carton-weight-lbs');
      this.napco_weight_per_piece_lbs = form.getAttribute('data-weight-per-piece-lbs');

      //Using CloudLab
      this.editor_version = form.getAttribute('data-editor-version');

      //Functions
      this.form.addEventListener('change', (e) => {

        // If size dropdown changed → rebuild qty options first
        if (e.target.classList.contains('js-size-option')) {
          const selectedSizeKey = e.target.value;

          if (this.multi_size_static_price && selectedSizeKey) {
            this.buildDynamicQtyOptions(selectedSizeKey);
          }
        }

        // Then validate everything
        this.validateForm();
      });

      //Constants
      this.eFluteCaliper = 0.0625;
      this.bFluteCaliper = 0.1250;

      
      if (document.getElementById('number-of-products')) {
        this.form.addEventListener('change', this.calculateCompanionBoxSize.bind(this));
        this.form.addEventListener('input', this.calculateCompanionBoxSize, false);
      }

      this.custom_cta.forEach(cta => 
        cta.addEventListener('click', (e) => this.displayCustomOption(e))
      );

      $(document).on('submitForm', function () {
        $('#atc').trigger('click');
      })

      $(document).ready( function () {
        let form = document.querySelector('.add-to-cart-form');
        if (form) {
          const e = new Event('change');
          form.dispatchEvent(e);
        }
      })

      this.form.addEventListener('submit', e => {
        e.preventDefault();
          //Grabs box details then uses add to cart function
          let details = this.getBoxDetails(this.form);
          if (!details) {
            return;
          }
          details._total_price = this.convertToMoney(details._total_price);

          //Predesigned addition
          this.predesigned = form.getAttribute('data-predesigned-predesigned');
          if(this.predesigned){
            this.predesigned_artwork_url = form.getAttribute('data-predesigned-predesigned_artwork_url');
            this.flood = form.getAttribute('data-predesigned-flood');

            //If predesigned and flood is false we need to append the dimensions to the predesigned artwork url
            //we need to not edit the base string because changing dimensions will continue to append
            let predesigned_artwork_url = this.predesigned_artwork_url
            if (this.flood == "false"){
                predesigned_artwork_url = predesigned_artwork_url + "-" + details._length + "x" + details._width + "x" + details._depth;
            }
            predesigned_artwork_url = predesigned_artwork_url + ".pdf"

            // Add predesigned, flood, and predesigned_artwork_url to order data detail
            details._predesigned = this.predesigned;
            details._flood = this.flood;
            details._predesigned_artwork_url = predesigned_artwork_url;
          }

          let customizedProductId = this.form.getAttribute('data-customized-product-id');

          if (details) {
            this.addToCart(details, customizedProductId).then(() => {
              let weight_item_cart_keys = (this.form.getAttribute('data-association-id-cart-keys') || "").split(",");
              let component_item_cart_keys = (this.form.getAttribute('data-related-component-prod-cart-keys') || "").split(",");
              let cart_keys = weight_item_cart_keys.concat(component_item_cart_keys).filter(key => !!key);
              if (cart_keys.length) {
                return $.get('/cart/update.json?' + cart_keys.map((key) => {
                  return 'updates[' + key + ']=0';
                }).join('&'));
              }
            })
            .then(() => {
              //fire pinterest add to cart event
              if (window.pintrk) {
                var atcDetails = {
                  value: details._total_price || 1.00,
                  order_quantity: details._item_qty || 1,
                  currency: 'USD', //couldn't get liquid to work here :-(
                  line_items: [ { product_id: details._variant_id || "no_id_available" } ]
                }

                pintrk('track', 'AddToCart', atcDetails)
              } else {
                console.error('pintrk not found.');
              }

              return true;
            }) 
            .finally(() => {
              window.location = '/cart';
            });
          }
      });
    }

    buildDynamicQtyOptions(selectedSizeKey) {

      const dropdownLabel = this.form.querySelector('.standard-box-quantity .js-dropdown-label');
      const qtyList = this.form.querySelector('.standard-box-quantity .js-dropdown-options-list');
      if (!qtyList) return;

      const config = this.multi_size_static_price ? this.multi_size_static_price[selectedSizeKey] : null;
      if (!config || !config.static_pricing) {
        return;
      }
      qtyList.innerHTML = '';

      this.standard_qty_list = [];
      this.static_price_list = [];

      let firstInput = null;

      config.static_pricing.forEach((pricing, index) => {

        const li = document.createElement('li');
        li.classList.add('radio');

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'standard-qty-option';
        input.classList.add('js-dropdown-option-radio', 'js-qty-option', 'is-hidden');
        input.value = pricing.quantity;
        input.id = `dynamic-qty-option-${index}`;

        if (index === 0) {
          firstInput = input;
        }

        const label = document.createElement('label');
        label.setAttribute('for', input.id);
        label.classList.add('js-dropdown-option-label', 'js-qty-option-label');

        label.innerHTML =
          '<span class="js-qty-span label-qty-option-span">' +
          pricing.quantity +
          '</span>' +
          '<span class="standard-qty-option-price"></span>';

        li.appendChild(input);
        li.appendChild(label);
        qtyList.appendChild(li);

        input.addEventListener('change', () => {
          if (dropdownLabel) {
            dropdownLabel.innerText = pricing.quantity;
          }
        });

        this.standard_qty_list.push(String(pricing.quantity));
        this.static_price_list.push(String(pricing.price));
      });

    if (firstInput) {
        firstInput.checked = true;
        firstInput.dispatchEvent(new Event('change'));
      }

      this.standard_qty_options =
        this.form.querySelectorAll('.js-qty-option-label .js-qty-span');

      if (this.form.hasAttribute('data-recalc')) {
        const recalc = this.form.getAttribute('data-recalc');
        const isRush = this.rush_production ? this.rush_production.checked : false;
        this.getPriceForQtyOptions(recalc, isRush);
      }
    }

    displayCustomOption(e) {
      e.preventDefault();
      let custom_cta = e.target;
      let closest_parent = custom_cta.closest('.js-box-option');
      let custom_container = closest_parent.getElementsByClassName('js-custom-input-container')[0];
      if(custom_container.classList.contains('is-hidden')) {
        custom_container.classList.remove('is-hidden');
        let option_radios = closest_parent.getElementsByClassName('js-dropdown-option-radio');
        for(let option of option_radios) {
          if(option.checked == true) {
            option.checked = false;
          }
        }
        closest_parent.getElementsByClassName('js-dropdown-label')[0].textContent = '---';
        closest_parent.getElementsByClassName('js-custom-input-msg')[0].classList.add('is-hidden');
        closest_parent.getElementsByClassName('js-custom-input-label')[0].classList.remove('is-hidden');
      } else {
        return
      }
    }

    getPriceForArea(area, breaks) {
      let brk = Object.keys(breaks).reduce(function (curr, next) {
        return (area >= +next && +next > curr) ? next : curr;
      }, 0);
      
      let unit_price = breaks[brk || 'default'].price_per;
      return unit_price * area;
    }

    // Using "Indirect" invocation of eval() runs code within it's own <script> tag and prevents scope creep of code ran
    getSafeEval(eq, dimensions, numOfProducts) {
      try {
        // Other ways you can call eval() indirectly: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#description
        const indirectEval = eval;
        return indirectEval(`
          let l = ${dimensions.length || 0};
          let w = ${dimensions.width || 0};
          let h = ${dimensions.depth || 0};
          let d = ${dimensions.depth || 0}; // Some equations use 'd' while some use 'h' to represent depth/height
          let cal = ${dimensions.caliper || 0};
          let nprod = ${numOfProducts || 0};
          ${eq}
        `);
      } catch (ex) {
        console.log(`Failed to evaluate equation: ${ex}`);
        return NaN;
      }
    }

    convertToMoney(price) {
      return (Math.ceil(price * 100) / 100.0).toFixed(2);
    }

    validateLength(validation, d) {
      if (!validation || !validation.minimums) {
        return true;
      } else {
        if (!validation.maximums) {
          return (validation.minimums.length <= d.length) && (validation.minimums.width <= d.width) && (validation.minimums.height <= d.depth);
        } else {
          // Evaluate minimums and maximums from the metafields. If there is no specific maximum, maximum = 0 as a default/placeholder and it automatically "skips" validation against the input and returns true
          return (validation.minimums.length <= d.length) && (validation.minimums.width <= d.width) && (validation.minimums.height <= d.depth) && (validation.maximums.length > 0 ? (validation.maximums.length >= d.length ? true: false) : true) && (validation.maximums.width > 0 ? (validation.maximums.width >= d.width ? true:  false) : true) && (validation.maximums.height > 0 ? (validation.maximums.height >= d.depth ? true: false) : true);
        }
      }
    }

    validateRatio(validation, d) {
      if (!validation) return true;
      const length_width = d.length / d.width;
      const length_height = d.length / d.depth;
      const height_width = d.depth / d.width;

      validation.ratios = validation.ratios || {};
      validation.max_ratios = validation.max_ratios || {};
      validation.min_ratios = validation.min_ratios || {};

      const rlw = +validation.ratios.length_width || 0;
      const xlw = +validation.max_ratios.length_width || 0;
      const nlw = +validation.min_ratios.length_width || 0;

      const rlh = +validation.ratios.length_height || 0;
      const xlh = +validation.max_ratios.length_height || 0;
      const nlh = +validation.min_ratios.length_height || 0;

      const rhw = +validation.ratios.height_width || 0;
      const xhw = +validation.max_ratios.height_width || 0;
      const nhw = +validation.min_ratios.height_width || 0;

      if (rlw && !(length_width == rlw)) return false;
      if (xlw && !(length_width <= xlw)) return false;
      if (nlw && !(length_width >= nlw)) return false;

      if (rlh && !(length_height == rlh)) return false;
      if (xlh && !(length_height <= xlh)) return false;
      if (nlh && !(length_height >= nlh)) return false;

      if (rhw && !(height_width == rhw)) return false;
      if (xhw && !(height_width <= xhw)) return false;
      if (nhw && !(height_width >= nhw)) return false;

      return true;
    }
    
    setMinQty(material) {

      // Get min value of currently checked material and set qty to min qty if it's > 1. 
      let min_qty_value = material != null ? Number(material.getAttribute('data-min-qty')) : 0;

      // If og qty is < min, then set qty to min and show msg indicating the min required amount
      if(min_qty_value > 1){
        if(this.standard_qty) {
          let standard_qty = this.form.querySelector('.js-qty-option:checked');
          let checked_qty = standard_qty ? Number(standard_qty.value) : null;

          if (checked_qty && checked_qty < min_qty_value) {
            standard_qty.checked = false;
            this.item_qty.value = checked_qty;
            this.form.querySelector(`input[value='${min_qty_value}']`).checked = true;
            this.form.querySelector('.js-standard-box-qty .js-dropdown-label').textContent = min_qty_value;
          }
        }

        //Set the min value
        if (Number(this.item_qty.value) < min_qty_value && this.form.querySelector('.material-min-qty') != null) {
          this.item_qty.value = min_qty_value;
          this.form.querySelector('.material-min-qty').textContent = 'There is a minimum quantity of ' + min_qty_value + ' for this material';
          this.form.querySelector('.material-min-qty').classList.remove('is-hidden');
        } else {
          this.item_qty.setAttribute('min', min_qty_value);
          this.form.querySelector('.material-min-qty')?.classList.add('is-hidden');
        }
      } else {
        // Reset to most recent material min qty val
        this.item_qty.setAttribute('min', min_qty_value);
        document.querySelector('.material-min-qty')?.classList.add('is-hidden');
      }
      
      return min_qty_value;
    }

    updateRushOption(total_area_sqft, rush_prod_checked, item_qty, current_variant) {
      // Get rush production but only adjust messaging if determining rush on current variant.

      let rush_production = '';
      let rush_maximum_sqft = parseInt('5000');
      let rush_maximum_quantity = parseInt('1000');
      let rush_minimum_quantity = parseInt('5');
      let sample_maximum_quantity = parseInt('4');
      
      
      if(item_qty <= sample_maximum_quantity) {
        rush_production = 'Sample';
        if(current_variant) {
          this.sample_option_msg.classList.remove('is-hidden');
          this.rush_option_msg.classList.add('is-hidden');
          if(rush_prod_checked) {
            this.rush_production.checked = false;
          }
        }
      } else if (item_qty > rush_maximum_quantity || item_qty < rush_minimum_quantity || total_area_sqft > rush_maximum_sqft) {
        rush_production = 'No';
        if(current_variant) {
          this.rush_option_msg.classList.add('is-hidden');
          this.sample_option_msg.classList.add('is-hidden');
          if(rush_prod_checked) {
            this.rush_production.checked = false;
          }
        }
      } else {
        rush_production = rush_prod_checked ? 'Yes' : 'No';
        if(current_variant) {
          this.rush_option_msg ? this.rush_option_msg.classList.remove('is-hidden') : '';
          this.sample_option_msg.classList.add('is-hidden');
        }
      }
      return rush_production;
    }

    // creates the standard qty options list on the product page
    getPriceForQtyOptions (recalc, is_rush_production) {
      recalc = JSON.parse(recalc);

      let qty_options = [];
      this.standard_qty_options.forEach(option => {
        qty_options.push({'qty': Number(option.innerText)});
      })

      if (this.static_price_list) {
          for (let i = 0; i < qty_options.length; i++) {
            let option = qty_options[i];
            option['total-surface-area'] = (recalc.a * option['qty']);
            option['total-surface-area-sqft'] = option['total-surface-area']/144;
            option['rush-prod'] = is_rush_production == false ? false: this.updateRushOption(option['total-surface-area-sqft'], is_rush_production, option['qty']);
            option['rush-prod-multiplier'] = option['rush-prod'] == 'Yes' ? 1.35 : 1;
            option['box-price']= this.static_price_list[i]; // find the matching price that goes with the quantity, don't set price by area
            option['total-box-price'] = ((option['box-price'] * recalc.m) * recalc.p) * option['rush-prod-multiplier'];
            option['price-per-box'] = (option['total-box-price']/option['qty']);
          }
      }
      else {
        qty_options.forEach(option => {
          option['total-surface-area'] = (recalc.a * option['qty']);
          option['total-surface-area-sqft'] = option['total-surface-area']/144;
          option['rush-prod'] = is_rush_production == false ? false: this.updateRushOption(option['total-surface-area-sqft'], is_rush_production, option['qty']);
          option['rush-prod-multiplier'] = option['rush-prod'] == 'Yes' ? 1.35 : 1;
          option['area-price']= this.getPriceForArea(option['total-surface-area'], this.product_area_breaks);
          option['box-price']= this.product_base_price + option['area-price'];
          option['total-box-price'] = ((option['box-price'] * recalc.m) * recalc.p) * option['rush-prod-multiplier'];
          option['price-per-box'] = (option['total-box-price']/option['qty']);
        });
      }

      this.standard_qty_options.forEach(label => {
        qty_options.forEach(option => {
          if(label.innerText == option['qty']) {
            if (document.getElementById('number-of-products'))
            {
              label.nextSibling.textContent = (`$${this.convertToMoney(option['price-per-box']).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1',)}/insert`);
            }
            else {
              label.nextSibling.textContent = (`$${this.convertToMoney(option['price-per-box']).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1',)}/box`);
            }
          }
        })
      })
    }

    // Calculate the flute size for this box using our formula, or an override if one is detected
    calculateFlute(dims, available_flutes, product_flute) {
      const override = this.getFluteOverride(product_flute);

      if (override) {
        return { ...override, overridden: true}
      }

      const selected_flute = {flute: null, source: null, overridden: false};

      if (!available_flutes) {
        return selected_flute;
      }

      const cubic_volume = dims.length * dims.width * dims.depth;

      if (isNaN(cubic_volume) || cubic_volume < 0) {
        return selected_flute;
      }

      var filtered_flutes = available_flutes.filter(flute => cubic_volume >= flute.threshold).sort((a,b) => b.threshold - a.threshold);
      if (!filtered_flutes.length) {
        selected_flute.flute = available_flutes[0].flute;
        selected_flute.source = "formula";
      } else {
        selected_flute.flute = filtered_flutes[0].flute;
        selected_flute.source = "formula";
      }

      return selected_flute;
    }

    // Flutes can be overriden either by the user via query params or
    // By the product via metafields. The query param takes precedence over the product
    getFluteOverride(product_flute) {
      const target = "flute_override";
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has(target)) {
        return {
          flute: urlParams.get(target),
          source: "user_override"
        }
      }

      if (product_flute) {
       return {flute: product_flute, source: "product_override"};
      }

      return null;
      
    }

    calculateCompanionBoxSize() {
      document.getElementById("companion-box-dimensions").style.display = "none";

      if (Number(this.number_of_products?.value) > 0 && Number(this.length?.value) > 0 && Number(this.width?.value) > 0 && Number(this.depth?.value) > 0) {
        let productDimensions = {};
        productDimensions.length = Number(this.length.value);
        productDimensions.width = Number(this.width.value);
        productDimensions.depth = Number(this.depth.value);

        let boxDimensions = {};
        boxDimensions.length = this.getSafeEval(this.companion_box_length_eqn_E, productDimensions, Number(this.number_of_products.value));
        boxDimensions.width = this.getSafeEval(this.companion_box_width_eqn_E, productDimensions, Number(this.number_of_products.value));
        boxDimensions.depth = this.getSafeEval(this.companion_box_height_eqn_E, productDimensions, Number(this.number_of_products.value));

        let flute = this.calculateFlute(boxDimensions, this.available_flutes, null);

        
        if (!flute.flute?.includes("E")) {
          boxDimensions.length = this.getSafeEval(this.companion_box_length_eqn_B, productDimensions, Number(this.number_of_products.value));
          boxDimensions.width = this.getSafeEval(this.companion_box_width_eqn_B, productDimensions, Number(this.number_of_products.value));
          boxDimensions.depth = this.getSafeEval(this.companion_box_height_eqn_B, productDimensions, Number(this.number_of_products.value));

          flute = this.calculateFlute(boxDimensions, this.available_flutes, null);
        }

        document.getElementById("companion-box-dimensions").textContent = JSON.stringify(boxDimensions).replace(/[{}"]/g, '').replace(/[:]/g, ': ').replace(/[,]/g, ', ');
        document.getElementById("companion-box-dimensions").style.display = "block";
      }
    }

    getBoxDetails() {
      // Build the lines to add to cart 

      // Check whether a min qty needs to be set
      const material_checked = this.form.querySelector('[name=material]:checked');
      if (!material_checked) {
        this.missing_details = 'material';
        return false;
      }
      // Pureprint checked to be used for separate dimension calculations
      const pureprint_checked = this.pureprint ? this.pureprint.checked : false;
      const pureprint_matte_checked = this.pureprint_matte ? this.pureprint_matte.checked : false;
      const pureprint_kraft_checked = this.pureprint_kraft ? this.pureprint_kraft.checked : false;
      const pureprint_matte_kraft_checked = this.pureprint_matte_kraft ? this.pureprint_matte_kraft.checked : false;
      const kraft_pureprint_checked = this.kraft_pureprint ? this.kraft_pureprint.checked : false;
      this.setMinQty(material_checked);

      // Check print options. If no print is checked and we switch to a material that has data-no-print-enabled="false", we switch to default and disable it.
      let no_print_enabled = material_checked?.getAttribute('data-no-print-enabled');
      if (this.no_print_finish != null) {
        if (no_print_enabled == "true") {
          this.no_print_finish.disabled = false;
          this.component_no_print_inputs.forEach((ele) => ele.disabled = false)
        } else {
          this.no_print_finish.disabled = true;
          this.component_no_print_inputs.forEach((ele) => ele.disabled = true)
          if (this.no_print_finish.checked == true) {
            this.default_print.checked = true
          }
          this.component_no_print_inputs.forEach(ele => {
            if(ele.checked) $(ele).closest(".enhancements").find(".custom-art.component-print-option").prop("checked", true)
          })
        }
      }

      // Check if there are standard or multi static sizes and grab them
      let dimensions = {};
      let selected_size = this.form.querySelector('.js-size-option:checked');
      let selected_multi_size = this.form.querySelector('.js-size-option');
      let selected_size_prop = '';

      let selectedValue = null;

      if (selected_size) {
        selectedValue = selected_size.value;
      } else if (
        selected_multi_size &&
        selected_multi_size.value &&
        selected_multi_size.value !== 'Select size...'
      ) {
        selectedValue = selected_multi_size.value;
      }

      if (selectedValue) {
        selected_size_prop = selectedValue.replace(/"/g, '');

        const get_numbers = /\d*\.?\d+/g;
        const dimensions_array = selectedValue.match(get_numbers);

        if (dimensions_array && dimensions_array.length === 3) {
          this.length.value = dimensions_array[0];
          this.width.value = dimensions_array[1];
          this.depth.value = dimensions_array[2];
        }
      }

      dimensions.length = Number(this.length?.value ?? 0);
      dimensions.width = Number(this.width?.value ?? 0);
      dimensions.depth = Number(this.depth?.value ?? 0);

      // Calculate the Flute size
      const flute = this.calculateFlute(dimensions, this.available_flutes, this.product_flute_override);

      // Set caliper based on flute
      dimensions.caliper = flute.flute && flute.flute.toLowerCase().includes('e') ? this.eFluteCaliper : this.bFluteCaliper;

      // Evaluate the dimensions
      const valid_lengths = this.validateLength(this.product_validation, dimensions);

      // new logic for f flute products (need to go on laser)
      const f_flute_max_sheet_width = parseInt('29');
      const f_flute_max_sheet_length = parseInt('40');

      let valid_dimension;
      let selectedWidth = this.getSafeEval(this.product_width_eqn, dimensions, Number(this.number_of_products?.value));
      let selectedLength = this.getSafeEval(this.product_length_eqn, dimensions, Number(this.number_of_products?.value));
      let allowedWidth = this.getSafeEval((pureprint_checked || pureprint_matte_checked || pureprint_kraft_checked || pureprint_matte_kraft_checked || kraft_pureprint_checked  ? this.material_width_pure_max : this.material_width_max), dimensions, Number(this.number_of_products?.value));
      let allowedLength = this.getSafeEval((pureprint_checked || pureprint_matte_checked || pureprint_kraft_checked || pureprint_matte_kraft_checked || kraft_pureprint_checked  ? this.material_length_pure_max : this.material_length_max), dimensions, Number(this.number_of_products?.value));

      if (this.product_tags && this.product_tags.includes('f flute')) {
        // F flute can only go laser - restrict the size no matter which material was selected
        valid_dimension = selectedWidth <= f_flute_max_sheet_width && selectedLength <= f_flute_max_sheet_length;
      } else {
        valid_dimension = selectedWidth <= allowedWidth && selectedLength <= allowedLength;
      }

      const valid_ratios = this.validateRatio(this.product_validation, dimensions);
      let standard_qty = document.querySelector('.js-qty-option:checked');

      if(valid_lengths){
        this.failed_comparison_validations = this.comparison_validation_eqns.map(eq => {
          let result = this.getSafeEval(eq.formula, dimensions);
          return !result ? eq.errorMessage : null; // If we failed to evaluate equation, return error message
        }).filter(m => m && !!m.trim()); // Filter out empty strings
      } else {
        this.failed_comparison_validations = [];
      }

      const raw_qty = standard_qty?.value ?? this.item_qty?.value ?? 0;
      const numeric_qty = raw_qty === '' ? 0 : raw_qty;
      this.item_qty.value = parseInt(numeric_qty);
      const item_qty = standard_qty ? standard_qty.value : this.item_qty ? this.item_qty.value : '';

      // if static pricing is used, find the matching price based on the selected qty
      let price_for_qty;
      if (this.standard_qty_list && this.static_price_list) {
        const item_qty_pos = this.standard_qty_list.indexOf(item_qty);
        price_for_qty = this.static_price_list[item_qty_pos];
      }

      // If any missing or failing validation, show specific msg and set details to false.
      if (!(item_qty > 0) || !valid_lengths || !valid_dimension || !valid_ratios) {
        if (this.length?.value == '' || this.width?.value == '' || this.depth?.value == '' ) {
          this.missing_details = 'empty_dimensions';
        } else {
          if (valid_lengths && valid_ratios && valid_dimension) {
            // If a statically-sized item, skip quantity validation until user updates quantity input
            if (selected_size && !this.quantityTouched) return;
            this.missing_details = 'qty';
          } else if (item_qty > 0) {
            this.missing_details = 'wrong_dimensions';
          } else {
            this.missing_details = 'both';
          }
        }
        return false;
      }

      // If divider + invalid number of products, everything else OK
      if (item_qty > 0 && valid_lengths && valid_dimension && valid_ratios && (document.getElementById('number-of-products') && Number(this.number_of_products?.value) < 2)) {
        this.missing_details = 'invalid_number_of_products';
        return false;
      }

      this.missing_details = "";
      
      if(this.failed_comparison_validations.length){
        return false;
      }


      const material = material_checked.value;
      const has_insideprint = this.inside_print ? this.inside_print.checked : false;
      const has_doublesided = this.doublesided_print ? this.doublesided_print.checked : false;
      const custom_art = (this.default_print && this.default_print.checked) || has_doublesided || has_insideprint;
      const has_varnish = custom_art && material_checked.getAttribute('data-support-varnish') == "true" ? true : false;
      const sample_maximum_quantity = parseInt('4');

      const weight_variant_id = material_checked.getAttribute('data-weight-variant-id');
      const area = this.getSafeEval(this.product_eqn, dimensions, Number(this.number_of_products?.value));
      const total_surface_area = area * item_qty;
      const total_surface_area_sqft = total_surface_area / 144;
      const blank_width = parseFloat(this.getSafeEval(this.product_width_eqn, dimensions, Number(this.number_of_products?.value)));
      const blank_length = parseFloat(this.getSafeEval(this.product_length_eqn, dimensions, Number(this.number_of_products?.value)));

      //Add attributes for testing purposes, to be sure we're over the maximum rush sqft threshold
      this.form.setAttribute('data-surface-area', area);
      this.form.setAttribute('data-total-area-sqft', total_surface_area_sqft);

      /* Rush prod calculations
      this.rush_production refers to rush being enabled site wide. If null/disabled, set to false and skip updating the rush option
      Use current_variant to differentiate between the qty option prices which are informative and the current variant whose information is used to add to cart. */
      let rush_prod_checked =  this.rush_production == null ? false : this.rush_production.checked;
      let current_variant = true;
      let rush_production = this.rush_production !== null ? this.updateRushOption(total_surface_area_sqft, rush_prod_checked, item_qty, current_variant) : item_qty > sample_maximum_quantity ? 'No' : 'Sample';
      rush_prod_checked = this.rush_production ? this.rush_production.checked : false;

      // Calculate prices based on box properties
      let box_price;
      if (price_for_qty) {
        box_price = price_for_qty;
      } else {
        const area_price = this.getPriceForArea(total_surface_area, this.product_area_breaks);
        box_price = this.product_base_price + area_price;
      }
      
      // Multiplier: art/print multiplier
      // NAPCO boxes sell at a flat static price per quantity - print/material are fixed for them, so neither should impact the price.
      const is_napco = this.product_tags?.includes('NAPCO');
      let multiplier = is_napco ? 1 : (1 +
        (custom_art && +this.default_print.getAttribute('data-price-multiplier') || 0) +
        (has_insideprint && +this.inside_print.getAttribute('data-price-multiplier') || 0) +
        (has_doublesided && +this.doublesided_print.getAttribute('data-price-multiplier') || 0) +
        (has_varnish && +this.varnish.getAttribute('data-price-multiplier-gloss') || 0));

      //Premium multiplier: material multiplier
      let premium_multiplier = is_napco ? 1 : (1 + (+material_checked.getAttribute('data-price-multiplier') || 0));
      let total_price = box_price * multiplier;
      total_price *= premium_multiplier;
      total_price *= (rush_prod_checked && +this.rush_production.getAttribute('data-rush-multiplier') ? (+this.rush_production.getAttribute('data-rush-multiplier')) : 1);

      const template = this.form.classList.item(1);
      const is_Napco = this.product_tags?.includes('NAPCO');
     
      //Box_properties used in cart/on checkout
      return {
        _is_rush_production: rush_prod_checked,
        _rush_production: rush_production,
        _length: dimensions.length,
        _width: dimensions.width,
        _depth: dimensions.depth,
        _caliper: dimensions.caliper,
        _selected_size: selected_size_prop,
        _material: material,
        _item_qty: item_qty,
        _custom_art: custom_art ? 'Yes' : 'No',
        _varnish: has_varnish ? 'Yes' : 'No',
        _inside_print: has_insideprint ? 'yes' : 'no', // case matters...
        _double_sided_print: has_doublesided ? 'yes' : 'no', // case matters...
        _area: area,
        _total_surface_area: total_surface_area,
        _total_surface_area_sqft: total_surface_area_sqft,
        _blank_width: blank_width,
        _blank_length: blank_length,
        _recalc: JSON.stringify({b:this.product_base_price, a:area, m:multiplier, p:premium_multiplier}),
        _total_price: total_price,
        _unit_price: this.convertToMoney(total_price/item_qty),
        _variant_id: this.variant_id,
        _weight_variant_id: weight_variant_id,
        _box_price: box_price,
        _unit_box_price: box_price / item_qty,
        _flute: flute.flute,
        _flute_source: flute.source,
        _flute_overridden: flute.overridden,
        _number_of_products: this.number_of_products != null ? Number(this.number_of_products.value) : 0,
        _mfg_facilities: JSON.stringify(this.mfg_facilities),
        _template: template,
        _is_static_multi_size: this.multi_size_static_price ? true : false,
        _glue: this.glue ? true : false,
        ...(is_Napco ? (() => {
          return {
            _NAPCO: true,
            _shipping_carton_dims_length: (this.napco_carton_dimensions && this.napco_carton_dimensions.length) || null,
            _shipping_carton_dims_width: (this.napco_carton_dimensions && this.napco_carton_dimensions.width) || null,
            _shipping_carton_dims_height: (this.napco_carton_dimensions && this.napco_carton_dimensions.height) || null,
            _shipping_carton_qty: (this.napco_carton_qty_per_break || []).find(t => t.qty === Number(item_qty))?.cartons || null,
            _shipping_carton_weight_lbs: this.napco_carton_weight_lbs || null,
            _weight_per_piece_lbs: this.napco_weight_per_piece_lbs || null
          };
        })() : {}),
        // The following capitalized fields are used for checkout display:
        Quantity: item_qty,
        Material: material,
        ...(this.rush_production !== null ? { Rush: rush_production } : {}),
        Print: (() => {
          if (!custom_art) {
              return "None";
          } else {
            if (has_insideprint) {
                return "Inside Only";
            } else if (has_doublesided) {
                return "Double Sided";
            } else{
              return "Outside Only";
            }
          }
        })(),
        ...(has_varnish || has_varnish === 'yes' ? { Varnish: 'Yes' } : {}),
      }
    }

    generateJsonLD(detailsObj){
      // https://schema.org/Product
      let jsonLDObj = {};
      jsonLDObj['@context'] = "https://schema.org/";
      jsonLDObj['@type'] = "Product";
      jsonLDObj['productId'] = $("*[data-itemprop=id]").text();
      jsonLDObj['image'] = [$("*[data-itemprop=image]").attr("src")];
      jsonLDObj['name'] = $(".product_name").text();
      jsonLDObj['description'] = $(".description").text();
      jsonLDObj['brand'] = {};
      jsonLDObj.brand['@type'] = "Brand";
      jsonLDObj.brand['name'] = "Boxmaker";
      jsonLDObj['offers'] = {};
      jsonLDObj.offers['@type'] = 'Offer';
      jsonLDObj.offers['price'] = detailsObj ? this.convertToMoney(detailsObj._total_price) : "40.00";
      jsonLDObj.offers['priceCurrency'] = 'USD';
      jsonLDObj.offers['seller'] = 'Fantastapack';
      jsonLDObj.offers['availability'] = $("*[data-itemprop=availability]").text() || "https://schema.org/InStock";
      jsonLDObj.offers['url'] = window.location.href;

      var scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'application/ld+json');
      scriptTag.text = JSON.stringify(jsonLDObj);
      document.head.appendChild(scriptTag);
    }

    validateForm() {
      const details = this.getBoxDetails();
      this.generateJsonLD(details);
      // Act on validity of details
      $('.add-to-cart-form').toggleClass('error', !details);
      $('.validationErrorMessage').remove(); // Clear current error messages

      if(!details) {
        this.form.querySelector('[type=submit]').disabled = true;
      } else {
        this.form.querySelector('[type=submit]').disabled = false;
      }

      if(this.design_online_enabled == "true") { 
        let design_online_cta = this.form.querySelector('.three-d-viewer-btn');

        if(design_online_cta) {
          if (this.editor_version == 'cloudlab') {
            // allow design online for inside print with CloudLab editor, disable editor for no print
            let noDesignOnline = !details || (this.no_print_finish && this.no_print_finish.checked == true); 
            noDesignOnline == true ? design_online_cta.disabled = true :  design_online_cta.disabled = false;
          }
        }
      }

      if (details) {
        if (document.getElementById('number-of-products')) {
          $('.price_per_box').text('($' + this.convertToMoney(details._total_price / details._item_qty).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '/insert)');
        }
        else {
          $('.price_per_box').text('($' + this.convertToMoney(details._total_price / details._item_qty).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '/box)');
        }
        $('.total_price .box_price').text(("$" + this.convertToMoney(details._total_price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")));
        $('#add-error-message').hide();
        $('.box-requirements').hide();
        $("#quantity-error-message").hide();
        $("#number-of-products-error-message").hide();

        this.missing_details = false;
        if(this.standard_qty_options) {
          this.getPriceForQtyOptions(details._recalc, details._is_rush_production);
        }
      } else {
        $(".top_price .box_price").text(selectionsBelow);
        $('.bottom_price .box_price').text(selectionsAbove);
        $('.price_per_box').text('');

        // For each failed comparison validation, create error element and display to user
        if(this.failed_comparison_validations.length){
          this.failed_comparison_validations.map(message => {
            let errorElement = document.createElement("div")
            errorElement.innerText = message;
            errorElement.classList.add("validationErrorMessage");
            this.form_error_message_container.prepend(errorElement);
          })
        }

        // Reset msg by hiding them all
        $('.box-requirements').hide();
        $('#add-error-message').hide();
        $("#quantity-error-message").hide();
        if (this.missing_details) {
          $("#number-of-products-error-message").hide();        
          if (this.missing_details == 'empty_dimensions') {
            $('.box-requirements').show();
          } else if (this.missing_details == 'wrong_dimensions') {
            $('#add-error-message').show();
          } else if (this.missing_details == 'both'){
            $('#add-error-message').show();
            $("#quantity-error-message").show();
          } else if (this.missing_details == 'invalid_number_of_products') {
            $("#number-of-products-error-message").show();
          } else {
            $("#quantity-error-message").show();
          }
        }
      }
    }

    try () {
      const product_validation = this.product_validation; // parse JSON
      this.form.querySelector('[name=l]').setAttribute('min', validation.minimums.length);
      this.form.querySelector('[name=w]').setAttribute('min', validation.minimums.width);
      this.form.querySelector('[name=h]').setAttribute('min', validation.minimums.height);
    } catch (ex) {
      // wtv... validate will catch errors anyways
    }

    buildCartItem(variant_id, quantity, properties) {
      const million_plus_add = (amount) => {
        const amount_to_add = Math.min(amount, 1000000);
        const chain = $.post('/cart/add.json', {
          id: variant_id,
          quantity: amount_to_add,
          properties: $.extend({ _count: Math.floor(amount / 1000000) }, properties),
        });
        if (amount_to_add < amount) {
          return chain.then(() => {
            return million_plus_add(amount - amount_to_add);
          });
        }
        return chain
      }
      return million_plus_add(quantity);
    }
    
    addToCart(details, customizedProductId) {
      if (customizedProductId) {
        // add the cloud lab data if it exists
        details._customizedProductId = customizedProductId;
      }

      let componentPromises = Promise.resolve();
      if(this.product_components.length){
        details._master_product_id = (+new Date) + '_' + Math.random().toString(36).substr(2);
        componentPromises = this.product_components.reduce((initialPromise, component, index) => {
          return initialPromise.then(() => {

            let group_props = {
              _association_id: (+new Date) + '_' + Math.random().toString(36).substr(2),
              _master_product_id: details._master_product_id
            }         
            // Set component product details
            let item_qty = component.qty * details._item_qty;
            let area = this.getSafeEval(component.surface_area, {length: component.length, width: component.width, depth: component.depth}, Number(1));
            let total_surface_area = area * item_qty;
            let total_surface_area_sqft = total_surface_area / 144;
            // per Alix, just use the length and width from the components metafield as the blank sizes
            const blank_width = component.width;
            const blank_length = component.length;
            let inside_print_input = this.form.querySelector(`#inside-print-${index}`);
            let custom_art_input = this.form.querySelector(`#custom-art-${index}`);
            let double_sided_input = this.form.querySelector(`#double-side-${index}`);
            let print_output = '';
  
            let has_insideprint = inside_print_input ? inside_print_input.checked : false;
            let has_doublesided = double_sided_input ? double_sided_input.checked : false;
            let has_custom_art = (custom_art_input && custom_art_input.checked) || has_doublesided || has_insideprint;
            
            let componentDetails = {
                _is_rush_production: details._is_rush_production,
                _rush_production: details._rush_production,
                _length: component.length,
                _width: component.width,
                _depth: component.depth,
                _material: details._material,
                _item_qty: item_qty,
                _custom_art: has_custom_art ? 'Yes' : 'No',
                _varnish: details.varnish,
                _recalc: JSON.stringify({b:0, a:area, m:0, p:0}),
                _total_price: 0,
                _unit_price: 0,
                _variant_id: component.variantId,
                _weight_variant_id: details._weight_variant_id,
                _box_price: 0,
                _unit_box_price: 0,
                _flute: component.flute ? component.flute : details._flute,
                _flute_source: component.flute ? "component_override" : details._flute_source,
                _flute_overridden: component.flute ? true : details._flute_overridden,
                _number_of_products: 1,
                _template: details._template,
                _is_static_multi_size: this.multi_size_static_price ? true : false,
                _area: area,
                _total_surface_area: total_surface_area,
                _total_surface_area_sqft: total_surface_area_sqft,
                _blank_width: blank_width,
                _blank_length: blank_length,
                _component_item: true,
                _component_to_product_ratio: component.qty,
                _inside_print: has_insideprint ? 'yes' : 'no', // case matters...
                _double_sided_print: has_doublesided ? 'yes' : 'no', // case matters...
                _mfg_facilities: JSON.stringify(this.mfg_facilities), //copy from parent product
                _glue: this.glue ? true : false,
                ...(details._NAPCO ? { _NAPCO: 'true' } : {}),
            }
            return new Promise((resolve, reject) => {
              return this.buildCartItem(component.variantId, 1, $.extend({}, group_props, {...componentDetails})).then(() => {
                  resolve();
            })})
          })
        }, Promise.resolve());
      }
      return componentPromises.then(() => {
        let group_props = {
          _association_id: (+new Date) + '_' + Math.random().toString(36).substr(2),
        }
        const parent_url = this.form.getAttribute('data-parent-url');
        const selected_size = this.form.querySelector('.js-size-option:checked');
        const size_handle = selected_size ? selected_size.getAttribute('data-handle') : null;
        //product_url_override is an auto redirect url for returning to the multi-product page view with the specific variant preselected
        const product_url_override = parent_url ? (size_handle ? parent_url + '?size=' + encodeURIComponent(size_handle) : parent_url) : null;
        return this.buildCartItem(details._variant_id, 1, $.extend({}, group_props, details, product_url_override ? { _product_url_override: product_url_override } : {}))
      })
    }
  }

  const selectionsBelow = "Based on Selections Below";
  const selectionsAbove = "Based on Selections Above";

  function initialize() {
    const urlParams = new URLSearchParams(window.location.search);
    const jwtParam = urlParams.get('jwt');

    // no params need to be set, OK to hide modal
    if (!urlParams || !jwtParam) {
      $('#cloudlab-loading-modal').hide();
    }
    
    document.querySelectorAll('.add-to-cart-form').forEach((form) => {
      form._productForm = new ProductForm({form});
    });
  }
  
  // Document ready
  $(() => {
    initialize();
  });

  $(document).on('shopify:section:load', () => {
    initialize();
  });

})(jQuery);